import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs, orderBy, updateDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import { Helmet } from "react-helmet";
import Cookies from 'js-cookie';
import { useToast } from '../../components/ToastContext';
import Statusbar from '../../master_root/statusbar';
import Loading from '../../components/loading';
import { MdSearch, MdAdd } from 'react-icons/md';

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import SortableItem from './projects-deshboard-sortableItem'; // ✅ <-- Add this line

import './projects.css';

export default function Projectsdeshboard() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const  adminguid  =  Cookies.get("adminguid");
  const [projectdata, setProjectdata] = useState([]);

  useEffect(() => {
    if (adminguid) fetchProjectsData(adminguid);
  }, [adminguid]);

  const fetchProjectsData = async () => {
    setIsLoading(true);
    try {
      const smsQuery = query(
        collection(db, "projects"),
        where("adminguid", "==", adminguid),
        where("status", "==", true),
        where("archived", "==", false),
        orderBy("indexstage", "desc")
      );
      const smsSnapshot = await getDocs(smsQuery);
      const dataList = smsSnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data()
      }));
      setProjectdata(dataList);
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = projectdata.findIndex((item) => item.id === active.id);
      const newIndex = projectdata.findIndex((item) => item.id === over.id);
      const newOrder = arrayMove(projectdata, oldIndex, newIndex);
      setProjectdata(newOrder);

      for (let i = 0; i < newOrder.length; i++) {
        const item = newOrder[i];
        const newIndexStage = newOrder.length - i; // descending
        if (item.indexstage !== newIndexStage) {
          await updateDoc(doc(db, "projects", item.id), { indexstage: newIndexStage });
        }
      }
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
    <div>
     
      <div className="container_roots">
        <Helmet>
          <title>Browse Job Tasks | EditorTask - Find & Hire Creative Talent</title>
          <meta name="description" content="Discover the latest freelance job tasks listed on EditorTask. From video editing to digital marketing, connect with top talent across India." />
        </Helmet>

        <div className="project-hd-body">
          <div className='project-hd'>
            <MdSearch className='search-img' />
            <input className='proj-search-input' placeholder='Projects' />
            <MdAdd onClick={() => navigate('/projects')} title='Add Project' className='add-project-img' />
          </div>

          {isLoading ? (
            <Loading />
          ) : projectdata.length === 0 ? (
            <p>No Project available.</p>
          ) : (
            <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
              <SortableContext
                items={projectdata.map((item) => item.id)}
                strategy={verticalListSortingStrategy}
              > 
                  {projectdata.map((datarow) => (
                    <SortableItem key={datarow.id} datarow={datarow} navigate={navigate} />
                  ))}
                
              </SortableContext>
            </DndContext>
          )}
        </div>
      </div>
    </div>
  );
}
